







import { Component, Vue } from 'vue-property-decorator'
import MonitorPage from '@/components/geofence_monitor/Monitor.vue'

@Component({
  components: {
    MonitorPage,
  },
})
export default class GeofenceMonitor extends Vue {}
